import React from "react";
import { Menu, message, Modal } from "antd";
import isEmpty from "lodash/isEmpty";
import startsWith from "lodash/startsWith";
import WeaCollect from "../wea-collect";
import { callApi } from "../wea-tools/callApi";
import { ls } from "../wea-tools/storage";
import Base64 from "../wea-tools/base64";
import { getLabel } from "../wea-locale-provider/util";
import ShowUrl from "../wea-show-url";
const confirm = Modal.confirm;
const Item = Menu.Item;
const SubMenu = Menu.SubMenu;

class RightMenu extends React.Component {
  static displayName = "RightMenu";
  static defaultProps = {
    datas: [],
    collectParams: undefined,
    helpParams: {}
  };
  constructor(props) {
    super(props);
    this.instanceIsMounted = false;
    this.state = {
      collectVisable: false,
      urlVisible: false,
      showUrlItem: false,
      maskClose: this.props.maskClose || false
    };
  }
  componentDidMount() {
    callApi("/api/ec/dev/app/getUserInfo", "GET").then(res => {
      this.setState({ showUrlItem: res.isAdmin });
    });
    this.instanceIsMounted = true;
  }
  componentWillUnmount() {
    this.instanceIsMounted = false;
  }
  onItemClick = (o, datas) => {
    datas.forEach((d, i) => {
      if (d.itemGroup && d.itemGroup.length) {
        d.itemGroup.forEach(g => {
          d.allowSelect &&
            g.key === o.key &&
            typeof g.onClick === "function" &&
            g.onClick(o.key, i);
        });
      } else {
        d.key === o.key && typeof d.onClick === "function" && d.onClick(o.key);
      }
    });
  };
  getMenu = datas => {
    return (
      <Menu
        mode="vertical"
        onClick={o => {
          if (o.key === "collect") {
            this.setState({ collectVisable: true }, () => {
              typeof this.props.showCollect === "function" &&
                this.props.showCollect(true);
            });
          } else if (o.key === "showURL") {
            this.setState({ urlVisible: true }, () => {
              typeof this.props.showUrlDialog === "function" &&
                this.props.showUrlDialog(true);
            });
          } else {
            const { onClick } = this.props;
            if (o.key !== "showHelp" && o.key !== "copy" && o.key !== "paste")
              typeof onClick === "function" && onClick(o.key);
            this.onItemClick(o, datas);
          }
        }}
      >
        {datas.map((d, i) => {
          if (d.itemGroup && d.itemGroup.length) {
            let hasSelect = false;
            if (d.selectKey && d.selectKey.length) {
              hasSelect = true;
            }
            return (
              <SubMenu
                key={d.key || i}
                title={
                  <span>
                    <span unselectable="on" className="wea-right-menu-icon">
                      {d.icon}
                    </span>
                    <span unselectable="on" title={d.title || d.content}>
                      {d.content}
                    </span>
                  </span>
                }
                disabled={d.disabled}
                className={
                  hasSelect ? "wea-submenu-selected" : "wea-submenu-unselected"
                }
              >
                {d.itemGroup.map(g => {
                  const {
                    key,
                    disabled,
                    icon,
                    title,
                    content,
                    itemGroupStyle
                  } = g;
                  return (
                    <Item
                      style={{
                        ...d.itemGroupStyle,
                        width: this.props.width ? this.props.width : "auto",
                        paddingLeft: hasSelect ? "20px" : null
                      }}
                      key={key}
                      disabled={disabled}
                    >
                      <li unselectable="on">
                        {d.selectKey.find(i => i === key) && (
                          <span
                            unselectable="on"
                            className="wea-right-submenu-icon"
                          >
                            <i
                              className="icon-coms-complete"
                              style={{ color: "#5BB5EF" }}
                            />
                          </span>
                        )}
                        <span unselectable="on" className="wea-right-menu-icon">
                          {icon}
                        </span>
                        <span unselectable="on" title={title || content}>
                          {content}
                        </span>
                      </li>
                    </Item>
                  );
                })}
              </SubMenu>
            );
          } else {
            return (
              <Item key={d.key || i} disabled={d.disabled}>
                <li unselectable="on" className="wea-right-menu-item">
                  <span unselectable="on" className="wea-right-menu-icon">
                    {d.icon}
                  </span>
                  <span unselectable="on" title={d.title || d.content}>
                    {d.content}
                  </span>
                </li>
              </Item>
            );
          }
        })}
      </Menu>
    );
  };
  getCollect = () => (
    <WeaCollect
      {...this.props.collectParams}
      visible={this.state.collectVisable}
      onClose={() => this.setState({ collectVisable: false })}
    />
  );
  getUrl = () => (
    <ShowUrl
      urlVisible={this.state.urlVisible}
      maskClose={this.state.maskClose}
      onCancel={() => this.setState({ urlVisible: false })}
    />
  );
  render() {
    const {
      datas: _datas,
      collectParams,
      inDialog = false,
      helpParams,
      activeElement,
      selectionStart,
      selectionEnd,
      isRM
    } = this.props;
    const { showUrlItem } = this.state;
    // localStorage.setItem(showCopyAndPaste, { showCopyAndPaste: 1 })
    const showHelp = ls.getJSONObj("showHelp") || { showHelp: "" };
    // const userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    // const isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
    // let isIE =
    //   userAgent.indexOf("compatible") > -1 &&
    //   userAgent.indexOf("MSIE") > -1 &&
    //   !isOpera;
    let showCopyAndPaste = {
      showCopyAndPaste: ""
    };
    let isIE = false;
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      isIE = true;
    }
    // const reIE = new RegExp("MSIE (\\d+\\.\\d+);");
    // reIE.test(userAgent);
    // const fIEVersion = parseFloat(RegExp["$1"]);
    // if (fIEVersion == 7) {
    //   isIE = true;
    // } else if (fIEVersion == 8) {
    //   isIE = true;
    // } else if (fIEVersion == 9) {
    //   isIE = true;
    // } else if (fIEVersion == 10) {
    //   isIE = true;
    // } else if (fIEVersion == 11) {
    //   isIE = true;
    // }
    // if (isIE) {
    showCopyAndPaste = ls.getJSONObj("showCopyAndPaste") || {
      showCopyAndPaste: ""
    };
    if (!isRM) {
      showCopyAndPaste = { showCopyAndPaste: "" };
    }
    // }
    const other = [];
    collectParams &&
      other.push({
        key: "collect",
        icon: <i className="icon-coms-Collection" />,
        content: getLabel("28111", "收藏")
      });
    (showHelp.showHelp === "true" ||
      (helpParams.helpDocid && helpParams.helpDocid !== "")) &&
      other.push({
        key: "showHelp",
        icon: <i className="icon-coms-help" />,
        content: getLabel(275, "帮助"),
        onClick: () => {
          let url = window.location.hash,
            tabKeys = window.tabKeys || [],
            urlParamsIndex = 0;
          url = url.replace("#/", "");
          url = url.replace("main/", "");
          url = url.slice(0, url.indexOf("?")); //去掉_key
          if (startsWith(url, "portal")) {
            inDialog ? (url = "portal/menu") : (url = "portal/summary");
          }
          Array.isArray(tabKeys) &&
            !isEmpty(tabKeys) &&
            tabKeys.forEach((v, l) => {
              const key = v.slice(v.indexOf("_key:") + 5, v.indexOf("_name:")),
                name = v.slice(v.indexOf("_name:") + 6);
              if (name !== "") {
                url += urlParamsIndex === 0 ? "?" : "&";
                // url += `key${urlParamsIndex}=${key},name${urlParamsIndex}=${name}`;
                url += `key${urlParamsIndex}=${key}`;
                urlParamsIndex++;
              }
            });
          // const Base64 = WeaTools.Base64;
          let src =
            "https://www.e-cology.com.cn/formmode/apps/ktree/ktreeHelpE9.jsp?pathKey=" +
            Base64.encode(url);
          !isEmpty(Object.keys(helpParams)) &&
            (src = "/spa/document/index.jsp?id=" + helpParams.helpDocid);
          const userLanguage = window.e9_locale
            ? window.e9_locale.userLanguage
            : 7;
          window.open(src + "&lang=" + userLanguage);
        }
      });
    showCopyAndPaste.showCopyAndPaste === "1" &&
      other.push(
        {
          key: "copy",
          icon: <i className="icon-coms-copy" />,
          content: `${getLabel("77", "复制")}(Ctrl+C)`,
          onClick: () => {
            document.execCommand("copy");
          }
        },
        {
          key: "paste",
          icon: <i className="icon-coms-Paste" />,
          content: `${getLabel("16180", "粘贴")}(Ctrl+V)`,
          onClick: () => {
            if (window.clipboardData) {
              const text = window.clipboardData.getData("Text") || "";
              const dom = document.querySelector("input:focus,textarea:focus");
              if (dom) {
                const start = dom.selectionStart;
                const end = dom.selectionEnd;
                const domText = dom.value;
                dom.value =
                  domText.substring(0, start) + text + domText.substring(end);
                if (dom.className.indexOf("ant-input") !== -1) {
                  // 文本框
                  dom.pasteValue =
                    domText.substring(0, start) + text + domText.substring(end);
                  dom.click(); // 手动触发文本框中input点击事件
                }
                if (dom.className === "ant-select-search__field") {
                  // 浏览按钮
                  dom.pasteValue =
                    domText.substring(0, start) + text + domText.substring(end);
                  dom.click(); // 手动触发浏览按钮中input点击事件
                }
                if (
                  dom.parentNode.parentNode.className === "wea-input-focus" ||
                  dom.parentNode.parentNode.className === "wea-textarea-normal"
                ) {
                  // wea-input-search
                  dom.pasteValue =
                    domText.substring(0, start) + text + domText.substring(end);
                  dom.click(); // 手动触发浏览按钮中input点击事件
                }
              }
            } else {
              const modal = confirm({
                title: getLabel(132010, "信息提示"),
                content: getLabel(
                  513710,
                  "由于Chrome安全策略的影响，无法粘贴，请使用键盘快捷键（Ctrl+V）来完成。"
                ),
                okCancel: false,
                okText: getLabel("83446", "确定"),
                onOk: () => {
                  if (activeElement) {
                    if (this.pasteAuto) clearTimeout(this.pasteAuto);
                    activeElement.focus();
                    setTimeout(() => {
                      activeElement.setSelectionRange(
                        selectionStart,
                        selectionEnd
                      );
                    }, 0);
                  }
                },
                onCancel: () => {
                  if (activeElement) {
                    if (this.pasteAuto) clearTimeout(this.pasteAuto);
                    activeElement.focus();
                    setTimeout(() => {
                      activeElement.setSelectionRange(
                        selectionStart,
                        selectionEnd
                      );
                    }, 0);
                  }
                }
              });
              this.pasteAuto = setTimeout(() => {
                if (modal) {
                  modal.destroy();
                  if (activeElement) {
                    activeElement.focus();
                    setTimeout(() => {
                      activeElement.setSelectionRange(
                        selectionStart,
                        selectionEnd
                      );
                    }, 0);
                  }
                }
                if (this.pasteAuto) clearTimeout(this.pasteAuto);
              }, 6000);
              return false;
            }
          }
        }
      );
    showUrlItem &&
      other.push({
        key: "showURL",
        icon: <i className="icon-coms-PageAddress" />,
        content: getLabel("21682", "显示页面地址")
      });

    const datas = _datas.concat(other);
    if (typeof this.props.customMenu === "function") {
      this.props.customMenu(datas);
    }
    this.isEmpty = datas.length === 0;
    if (datas.length === 0) return null;
    const list = [
      <iframe className="wea-right-menu-iframe" />,
      <div className="wea-right-menu-icon-background" />,
      this.getMenu(datas)
    ];
    collectParams && list.push(this.getCollect());
    showUrlItem && list.push(this.getUrl());
    return list;
  }
}

export default RightMenu;



// WEBPACK FOOTER //
// ./ecology9/wea-right-menu/RightMenu.js